import * as React from "react";

import { IEventViewProps } from "../EventView";

import { IEvent } from "../../../classes/Event";
import { IText } from "../../../classes/Text";

import * as dates from "../../../reducers/changeTimePeriod";

import { displayEventDetails, redirectToEventDetails } from "../../Common/buttonEvents";

export interface IMonthlyListEventProps {
    event: IEvent;
    eventText: string;
    allDayText: string;
    onText: string;
    toText: string;
    contextId: number;
    selectedDate: Date;
    pageId: number;
    parentId: number;
    portalId: number;
    portletInstanceId: number;
    showCategoryColumn: boolean;
    showLocationColumn: boolean;
    todaysDate: Date;
    userDateFormat: string;
    viewMode: string;
    onStartAjaxCall: (event: any) => any;
    onSetEventId: (event: any) => any;
    onSetEventScreenMode: (eventScreenMode: string) => any;
    onSetiCalStartDate: (event: any) => any;
    onSetDisplayedEventLocalStartDate: (localStartDate: Date) => any;
    onSetDisplayedEventLocalEndDate: (localEndDate: Date) => any;
}

export const MonthlyListEvent = (props: IMonthlyListEventProps) => {

    const event = props.event;
    const eventID = event.eventID;
    const showCategoryColumn = props.showCategoryColumn;
    const showLocationColumn = props.showLocationColumn;

    let trStyle = {};
    let anchorStyle = {};
    if (event.color) {
        trStyle = { backgroundColor: event.color, color: "#ffffff" };
        anchorStyle = { color: "#ffffff" };
    }

    const compactDateRange = dates.eventDescriptionMonthlyList(event, props.allDayText);
    const screenReaderDateRange = dates.eventDescriptionMonthlyList_Screenreader(event, props.allDayText, props.onText, props.toText);

    const onSetEventId = () => {
        props.onSetEventId(eventID);
    };

    const onSetEventScreenModeToView = () => {
        props.onSetEventScreenMode("VIEW");
    };

    const onSetiCalStartDate = () => {
        props.onSetiCalStartDate(event.localStartDate);
    };

    const onSetDisplayedEventLocalStartDate = () => {
        props.onSetDisplayedEventLocalStartDate(event.localStartDate);
    };

    const onSetDisplayedEventLocalEndDate = () => {
        props.onSetDisplayedEventLocalEndDate(event.localEndDate);
    };

    return (
        <tr className="CAL-V-LV-list" style={trStyle}>
            <td className="CAL-V-LV-name">
                {/*<span className="offScreen">Name:</span><a href="#!" style={anchorStyle} onClick={(e) => redirectToEventDetails(e, eventID, eventReference, contextId, selectedDate, todaysDate, pageId, parentId, portalId, portletInstanceId, viewMode, onStartAjaxCall)}>*/}
                <a href="#!" style={anchorStyle} onClick={(e) => displayEventDetails(e, eventID, onSetEventId, onSetEventScreenModeToView, onSetiCalStartDate, onSetDisplayedEventLocalStartDate, onSetDisplayedEventLocalEndDate)}>
                    {event.icon &&
                        <img src={event.icon} aria-hidden="true" className="mCS_img_loaded" />
                    }
                    <span className="offScreen">{props.eventText} </span>{props.event.name}
                    <span className="offScreen">{screenReaderDateRange}</span>
                </a>
            </td>
            <td className="CAL-V-LV-time" aria-hidden="true">
                <em aria-hidden="true" className="fa fa-clock-o"></em>&nbsp;
                <span aria-hidden="true">{compactDateRange}</span>
            </td>
            {showLocationColumn &&
                <td className="CAL-V-LV-location" aria-hidden="true">
                    {event.location &&
                        <React.Fragment>
                            <em aria-hidden="true" className="fa fa-map-pin"></em><span className="offScreen">Location:</span> {event.location}
                        </React.Fragment>
                    }
                </td>
            }
            {showCategoryColumn &&
                <td className="CAL-V-LV-tags" aria-hidden="true">
                    {event.category &&
                        <React.Fragment>
                            <em aria-hidden="true" className="fa fa-tag"></em> <span className="offScreen">Category:</span> {event.category}
                        </React.Fragment>
                    }
                </td>
            }
        </tr>
    );
};
